module.exports = __webpack_public_path__ + "img/8.7f78ede7.jpg";